// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeblog {
  padding: 15px 30px !important;
  padding: 0px !important;
}

.blog-side-embed {
  width: 100%;
  margin-top: 16px;
  text-align: left;
}

.blog-side-embed__frame-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 5/6;
  overflow: hidden;
  border-radius: 12px;
  background: #f1f5f9;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.blog-side-embed__iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #ffffff;
}

h2 {
  margin-bottom: 20px !important;
}
h2:first-child {
  margin-bottom: 0px !important;
}

.image-wrap {
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 30px 0px 20px;
}
.image-wrap img {
  width: 50%;
  max-height: 60px;
  margin-bottom: 20px;
}

.load-more {
  padding: 20px 50px 30px;
}
.load-more button {
  font-size: 16px;
  background: #fff;
  border: 0;
  border-radius: 0;
  color: #000;
  padding: 10px 20px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 50px;
  opacity: 1;
  margin: 0px auto;
  min-width: 180px;
  display: block;
  border: 1px solid #b34bc9;
}
.load-more button:hover {
  background: #b34bc9;
  background: #ff8f23;
  color: #fff;
}

.card-handler {
  padding-bottom: 0px;
  padding-top: 0px !important;
}

.handler {
  width: 100%;
  margin-bottom: 10px;
}
.handler:last-child {
  margin-bottom: 0px;
}

.hashcategory {
  display: flex;
  padding: 0px;
  margin: 0px;
  list-style: none;
  align-self: flex-start;
  flex-wrap: wrap;
  padding-right: 12px;
  padding-left: 0px !important;
  margin-bottom: 0px;
}
.hashcategory li {
  padding: 10px;
  border: 1px solid #5ea1d8;
  border-radius: 18px;
  display: block;
  margin: 0 12px 12px 0;
}

@media (max-width: 992px) {
  .hashcategory {
    padding: 0px !important;
  }
  h2 {
    font-size: 23px !important;
  }
}
.common-overlap {
  padding: 2rem 3rem;
}
.common-overlap:nth-child(even) {
  background: #fff;
}

.paratext-wrap p {
  text-align: left;
}

.author-details {
  text-align: left;
}
.author-details p {
  padding: 0px;
  margin-bottom: 15px !important;
}
.author-details p:first-child span {
  font-weight: bold;
}
.author-details p:last-child {
  margin-bottom: 0px !important;
  border-bottom: 1px solid #c4c5ca;
  padding: 10px 0px;
  display: inline-block;
  max-width: 400px;
  width: 100%;
}
.author-details a {
  text-align: left;
  display: block;
}
.author-details:last-child {
  margin-bottom: 20px !important;
}

img {
  max-width: 100%;
}

/* Ensure the cover image on the left is responsive and spaced */
.image-parent {
  width: 100%;
  margin-top: 12px;
}
.image-parent img {
  width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
}

.paratext-wrap p {
  padding: 0px;
  font-size: 18px !important;
  line-height: 26px !important;
  -webkit-line-clamp: unset !important;
  text-align: left;
}
.paratext-wrap p:last-child {
  margin-bottom: 0px;
}

p {
  text-align: left !important;
}

.delete-button {
  background-color: #5ea1d8 !important;
  color: white !important;
}

.action-icons {
  display: flex;
  margin-top: 27px;
  gap: 10px;
}

.action-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #1f2937;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}

.action-icon-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.action-icon-btn:hover {
  background: #f3f4f6;
}

.action-icon-btn.edit-icon {
  color: #2563eb;
}

.action-icon-btn.delete-icon {
  color: #dc2626;
}

.view-all-blogs-link {
  cursor: pointer;
  margin-left: 10px;
  color: #5ea1d8;
  text-decoration: underline;
}

.view-all-blogs-link:hover {
  color: #4a8fc4;
}

/* Blog details skeleton that mirrors final page layout */
.blog-title-skeleton {
  width: min(760px, 90%);
  height: 32px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.blog-detail-skeleton {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 24px;
  width: 100%;
}

.skeleton-left-column,
.skeleton-right-column {
  display: flex;
  flex-direction: column;
}

.skeleton-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.skeleton-chip {
  width: 90px;
  height: 32px;
  border-radius: 20px;
}

.skeleton-line {
  height: 16px;
  border-radius: 6px;
  margin-bottom: 12px;
  width: 92%;
}

.skeleton-line.short {
  width: 62%;
}

.skeleton-line.medium {
  width: 74%;
}

.skeleton-image {
  width: 100%;
  aspect-ratio: 16/10;
  border-radius: 12px;
  margin-top: 6px;
}

.skeleton-paragraph-line {
  height: 15px;
  border-radius: 6px;
  margin-bottom: 12px;
  width: 100%;
}

.skeleton-paragraph-line.short {
  width: 68%;
}

.skeleton-paragraph-line.medium {
  width: 84%;
}

.shimmer {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: blog-skeleton-shimmer 1.4s ease-in-out infinite;
}

@keyframes blog-skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
/* Mobile optimizations for blog detail page */
@media (max-width: 768px) {
  .blog-detail-skeleton {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .blog-title-skeleton {
    width: 100%;
    height: 28px;
  }
  .skeleton-image {
    aspect-ratio: 16/9;
  }
  .common-overlap {
    padding: 1.2rem 1.2rem;
  }
  .homeblog {
    padding: 0 0.5rem !important;
  }
  /* Stack image and content vertically on small screens */
  .handler.row,
  .card-handler .row {
    display: block;
  }
  .col-sm-4,
  .col-sm-8 {
    width: 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  .image-parent {
    margin-top: 16px;
  }
  .image-parent img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .paratext-wrap {
    margin-top: 16px;
  }
  .blog-side-embed {
    margin-top: 16px;
  }
}
:host-context(body.theme-dark) .shimmer {
  background: linear-gradient(90deg, #1f2937 25%, #334155 50%, #1f2937 75%);
  background-size: 200% 100%;
}
:host-context(body.theme-dark) .view-all-blogs-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-all-blogs-link:hover {
  color: #bfdbfe !important;
}
:host-context(body.theme-dark) .action-icon-btn {
  background: #111827;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .action-icon-btn:hover {
  background: #1f2937;
}
:host-context(body.theme-dark) .action-icon-btn.edit-icon {
  color: #93c5fd;
}
:host-context(body.theme-dark) .action-icon-btn.delete-icon {
  color: #fca5a5;
}
:host-context(body.theme-dark) .blog-side-embed__frame-wrap {
  background: #0f172a;
}
:host-context(body.theme-dark) .blog-side-embed__iframe {
  background: #111827;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/blogs/blog/blog.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,8BAAA;AACF;AACE;EACE,6BAAA;AACJ;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AAAF;AAEE;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,uBAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mDAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AADJ;AAGI;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;AADN;;AAMA;EACE,mBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,mBAAA;AAHF;AAKE;EACE,kBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AAJF;AAME;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAJJ;;AAQA;EACE;IACE,uBAAA;EALF;EAQA;IACE,0BAAA;EANF;AACF;AASA;EACE,kBAAA;AAPF;AASE;EACE,gBAAA;AAPJ;;AAYE;EACE,gBAAA;AATJ;;AAaA;EACE,gBAAA;AAVF;AAYE;EACE,YAAA;EACA,8BAAA;AAVJ;AAaM;EACE,iBAAA;AAXR;AAeI;EACE,6BAAA;EAEA,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AAdN;AAkBE;EACE,gBAAA;EAEA,cAAA;AAjBJ;AAoBE;EACE,8BAAA;AAlBJ;;AAsBA;EACE,eAAA;AAnBF;;AAsBA,gEAAA;AACA;EACE,WAAA;EACA,gBAAA;AAnBF;AAqBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAnBJ;;AAyBE;EACE,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,kBAAA;AAtBN;;AA2BA;EACE,2BAAA;AAxBF;;AA2BA;EACE,oCAAA;EACA,uBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AAxBF;;AA2BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,mBAAA;AAxBF;;AA2BA;EACE,cAAA;AAxBF;;AA2BA;EACE,cAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AAxBF;;AA2BA;EACE,cAAA;AAxBF;;AA2BA,yDAAA;AACA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,WAAA;AAxBF;;AA2BA;;EAEE,aAAA;EACA,sBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,yEAAA;EACA,0BAAA;EACA,0DAAA;AAxBF;;AA2BA;EACE;IACE,4BAAA;EAxBF;EA0BA;IACE,2BAAA;EAxBF;AACF;AA2BA,8CAAA;AACA;EACE;IACE,0BAAA;IACA,SAAA;EAzBF;EA4BA;IACE,WAAA;IACA,YAAA;EA1BF;EA6BA;IACE,kBAAA;EA3BF;EA8BA;IACE,sBAAA;EA5BF;EA+BA;IACE,4BAAA;EA7BF;EAgCA,wDAAA;EACA;;IAEE,cAAA;EA9BF;EAiCA;;IAEE,WAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;EA/BF;EAkCA;IACE,gBAAA;EAhCF;EAkCE;IACE,WAAA;IACA,eAAA;IACA,YAAA;EAhCJ;EAoCA;IACE,gBAAA;EAlCF;EAqCA;IACE,gBAAA;EAnCF;AACF;AAuCE;EACE,yEAAA;EACA,0BAAA;AArCJ;AAwCE;EACE,yBAAA;AAtCJ;AAyCE;EACE,yBAAA;AAvCJ;AA0CE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAxCJ;AA2CE;EACE,mBAAA;AAzCJ;AA4CE;EACE,cAAA;AA1CJ;AA6CE;EACE,cAAA;AA3CJ;AA8CE;EACE,mBAAA;AA5CJ;AA+CE;EACE,mBAAA;AA7CJ","sourcesContent":[".homeblog {\n  padding: 15px 30px !important;\n  padding: 0px !important;\n}\n\n.blog-side-embed {\n  width: 100%;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.blog-side-embed__frame-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 5 / 6;\n  overflow: hidden;\n  border-radius: 12px;\n  background: #f1f5f9;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.blog-side-embed__iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n  background: #ffffff;\n}\n\nh2 {\n  margin-bottom: 20px !important;\n\n  &:first-child {\n    margin-bottom: 0px !important;\n  }\n}\n\n.image-wrap {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding: 30px 0px 20px;\n\n  img {\n    width: 50%;\n    max-height: 60px;\n    margin-bottom: 20px;\n  }\n}\n\n.load-more {\n  padding: 20px 50px 30px;\n\n  button {\n    font-size: 16px;\n    background: #fff;\n    border: 0;\n    border-radius: 0;\n    color: #000;\n    padding: 10px 20px;\n    font-weight: 500;\n    white-space: nowrap;\n    box-shadow: 0px 3px 6px #00000029;\n    border-radius: 50px;\n    opacity: 1;\n    margin: 0px auto;\n    min-width: 180px;\n    display: block;\n    border: 1px solid #b34bc9;\n\n    &:hover {\n      background: #b34bc9;\n      background: #ff8f23;\n      color: #fff;\n    }\n  }\n}\n\n.card-handler {\n  padding-bottom: 0px;\n  padding-top: 0px !important;\n}\n\n.handler {\n  width: 100%;\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n}\n\n.hashcategory {\n  display: flex;\n  padding: 0px;\n  margin: 0px;\n  list-style: none;\n  align-self: flex-start;\n  flex-wrap: wrap;\n  padding-right: 12px;\n  padding-left: 0px !important;\n  margin-bottom: 0px;\n\n  li {\n    padding: 10px;\n    border: 1px solid #5ea1d8;\n    border-radius: 18px;\n    display: block;\n    margin: 0 12px 12px 0;\n  }\n}\n\n@media (max-width: 992px) {\n  .hashcategory {\n    padding: 0px !important;\n  }\n\n  h2 {\n    font-size: 23px !important;\n  }\n}\n\n.common-overlap {\n  padding: 2rem 3rem;\n\n  &:nth-child(even) {\n    background: #fff;\n  }\n}\n\n.paratext-wrap {\n  p {\n    text-align: left;\n  }\n}\n\n.author-details {\n  text-align: left;\n\n  p {\n    padding: 0px;\n    margin-bottom: 15px !important;\n\n    &:first-child {\n      span {\n        font-weight: bold;\n      }\n    }\n\n    &:last-child {\n      margin-bottom: 0px !important;\n      // border-top: 1px solid #c4c5ca;\n      border-bottom: 1px solid #c4c5ca;\n      padding: 10px 0px;\n      display: inline-block;\n      max-width: 400px;\n      width: 100%;\n    }\n  }\n\n  a {\n    text-align: left;\n\n    display: block;\n  }\n\n  &:last-child {\n    margin-bottom: 20px !important;\n  }\n}\n\nimg {\n  max-width: 100%;\n}\n\n/* Ensure the cover image on the left is responsive and spaced */\n.image-parent {\n  width: 100%;\n  margin-top: 12px;\n\n  img {\n    width: 100%;\n    height: auto;\n    border-radius: 12px;\n    object-fit: cover;\n  }\n}\n\n.paratext-wrap {\n  // margin-bottom:25px;\n  p {\n    padding: 0px;\n    font-size: 18px !important;\n    line-height: 26px !important;\n    -webkit-line-clamp: unset !important;\n    text-align: left;\n\n    &:last-child {\n      margin-bottom: 0px;\n    }\n  }\n}\n\np {\n  text-align: left !important;\n}\n\n.delete-button {\n  background-color: #5ea1d8 !important;\n  color: white !important;\n}\n\n.action-icons {\n  display: flex;\n  margin-top: 27px;\n  gap: 10px;\n}\n\n.action-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #1f2937;\n  cursor: pointer;\n  padding: 0;\n  transition: all 0.2s ease;\n}\n\n.action-icon-btn mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n\n.action-icon-btn:hover {\n  background: #f3f4f6;\n}\n\n.action-icon-btn.edit-icon {\n  color: #2563eb;\n}\n\n.action-icon-btn.delete-icon {\n  color: #dc2626;\n}\n\n.view-all-blogs-link {\n  cursor: pointer;\n  margin-left: 10px;\n  color: #5ea1d8;\n  text-decoration: underline;\n}\n\n.view-all-blogs-link:hover {\n  color: #4a8fc4;\n}\n\n/* Blog details skeleton that mirrors final page layout */\n.blog-title-skeleton {\n  width: min(760px, 90%);\n  height: 32px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.blog-detail-skeleton {\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  gap: 24px;\n  width: 100%;\n}\n\n.skeleton-left-column,\n.skeleton-right-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.skeleton-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.skeleton-chip {\n  width: 90px;\n  height: 32px;\n  border-radius: 20px;\n}\n\n.skeleton-line {\n  height: 16px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  width: 92%;\n}\n\n.skeleton-line.short {\n  width: 62%;\n}\n\n.skeleton-line.medium {\n  width: 74%;\n}\n\n.skeleton-image {\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  border-radius: 12px;\n  margin-top: 6px;\n}\n\n.skeleton-paragraph-line {\n  height: 15px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  width: 100%;\n}\n\n.skeleton-paragraph-line.short {\n  width: 68%;\n}\n\n.skeleton-paragraph-line.medium {\n  width: 84%;\n}\n\n.shimmer {\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: blog-skeleton-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes blog-skeleton-shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Mobile optimizations for blog detail page */\n@media (max-width: 768px) {\n  .blog-detail-skeleton {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .blog-title-skeleton {\n    width: 100%;\n    height: 28px;\n  }\n\n  .skeleton-image {\n    aspect-ratio: 16 / 9;\n  }\n\n  .common-overlap {\n    padding: 1.2rem 1.2rem;\n  }\n\n  .homeblog {\n    padding: 0 0.5rem !important;\n  }\n\n  /* Stack image and content vertically on small screens */\n  .handler.row,\n  .card-handler .row {\n    display: block;\n  }\n\n  .col-sm-4,\n  .col-sm-8 {\n    width: 100%;\n    max-width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .image-parent {\n    margin-top: 16px;\n\n    img {\n      width: 100%;\n      max-width: 100%;\n      height: auto;\n    }\n  }\n\n  .paratext-wrap {\n    margin-top: 16px;\n  }\n\n  .blog-side-embed {\n    margin-top: 16px;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .shimmer {\n    background: linear-gradient(90deg, #1f2937 25%, #334155 50%, #1f2937 75%);\n    background-size: 200% 100%;\n  }\n\n  .view-all-blogs-link {\n    color: #93c5fd !important;\n  }\n\n  .view-all-blogs-link:hover {\n    color: #bfdbfe !important;\n  }\n\n  .action-icon-btn {\n    background: #111827;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .action-icon-btn:hover {\n    background: #1f2937;\n  }\n\n  .action-icon-btn.edit-icon {\n    color: #93c5fd;\n  }\n\n  .action-icon-btn.delete-icon {\n    color: #fca5a5;\n  }\n\n  .blog-side-embed__frame-wrap {\n    background: #0f172a;\n  }\n\n  .blog-side-embed__iframe {\n    background: #111827;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
